import { FC } from 'react';
import { FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { ButtonPrimary, Form } from '@lambdacurry/component-library';
import { getQueryParam } from 'lib/util';
import { Card, CardContent, Container, Grid, Layout } from 'lib/components';
import { confirmPasswordInitialValues } from 'lib/forms/initialValues';
import { confirmPasswordValidation } from 'lib/forms/validation';
import { useResetPasswordMutation } from 'lib/home/generated/queries';
import { useLogin } from '../../hooks';
import { ConfirmPasswordInputGroup } from '../../components';

const initialValues = { ...confirmPasswordInitialValues };
const validationSchema = Yup.object({ ...confirmPasswordValidation });
type FormValues = typeof initialValues;

const ResetPasswordPage: FC = () => {
  const login = useLogin();

  const { mutate } = useResetPasswordMutation({
    onSuccess: data => {
      const { token } = data.resetPassword;
      login(token, { redirectPath: '/account' });
    }
  });

  const handleSubmit = ({ new_password }: FormValues, formikHelpers: FormikHelpers<FormValues>) => {
    const token = getQueryParam('token');

    mutate({ resetPasswordInput: { new_password, forgot_password_token: token } });
  };

  return (
    <Layout>
      <Container>
        <Grid>
          <div className="col-span-12 lg:col-span-10 lg:col-start-2">
            <Card>
              <CardContent>
                <h3>Reset Password</h3>

                <Form<FormValues>
                  validationSchema={validationSchema}
                  initialValues={initialValues}
                  onSubmit={handleSubmit}
                >
                  {formikProps => (
                    <>
                      <ConfirmPasswordInputGroup />
                      <ButtonPrimary type="submit">Submit</ButtonPrimary>
                    </>
                  )}
                </Form>
              </CardContent>
            </Card>
          </div>
        </Grid>
      </Container>
    </Layout>
  );
};

export default ResetPasswordPage;
